module.exports = __webpack_public_path__ + "media/images/LogoProefDePerfectie-0c2aa7832210776232250c97776603b6.png";